import React from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Button,
  createStyles,
  makeStyles,
  MenuItem,
  Select,
  Theme,
  Typography,
} from "@material-ui/core";
import OrderStatus from "types/enum/OrderStatus";
import EnumUtils from "utils/EnumUtils";
import StaffRole from "types/enum/StaffRole";
import DateTimeUtils, { FORMAT_TYPE } from "utils/DateTimeUtils";
import OrderRes from "types/res/order/OrderRes";
import OrderApi from "api/OrderApi";
import { Alert, AlertTitle } from "@material-ui/lab";
import { useSelector } from "react-redux";

type Props = {
  formData: any;
  onChangeForm: (key: string) => any;
  onClickCreateOrder: any;
  orderId: any;
  oldOrder: any;
  duplicateOrder: any;
  holdOrder: OrderRes;
  setHoldOrder: any;
  setDuplicateMessage: any;
  errorMessage: any;
  isSuccess: boolean;
  duplicateMessage: any;
  setDuplicateOrder: any;
};
const OrderSubmit: React.FC<Props> = ({
  formData,
  onChangeForm,
  onClickCreateOrder,
  orderId,
  oldOrder,
  duplicateOrder,
  holdOrder,
  setHoldOrder,
  setDuplicateMessage,
  errorMessage,
  isSuccess,
  duplicateMessage,
  setDuplicateOrder,
}) => {
  const { t } = useTranslation("order");
  const companyId = useSelector((state) => state.account.staff.companyId);
  const staff = useSelector((state) => state.account.staff);
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      button: {
        margin: theme.spacing(1),
      },
    })
  );
  const classes = useStyles();

  return (
    <>
      <Box display="flex" flexDirection="column">
        <Box height={holdOrder?.orderId ? 350 : 200}>
          {holdOrder?.orderId && (
            <Box
              display="flex"
              flexDirection="column"
              flexGrow={1}
              style={{
                padding: "10px",
                border: "1px solid black",
                borderRadius: "4px",
                width: "400px",
              }}
            >
              <Typography variant="body1">
                {t("orderSubmit.shopName")}：{holdOrder?.shop?.name || t("orderSubmit.unset")}
              </Typography>
              <Typography variant="body1">
                {t("orderSubmit.guestName")}：{holdOrder?.guest?.name || t("orderSubmit.unset")}
              </Typography>
              <Typography variant="body1">
                {t("orderSubmit.guestTel")}：{holdOrder?.guest?.tel || t("orderSubmit.unset")}
              </Typography>
              <Typography variant="body1">
                {t("orderSubmit.castName")}：{holdOrder?.castName?.name || t("orderSubmit.unset")}
              </Typography>
              <Typography variant="body1">
                {t("orderSubmit.totalTime")}：{holdOrder?.totalTime || 0}{t("orderSubmit.minutesSuffix")}
              </Typography>
              <Typography variant="body1">
                {t("orderSubmit.addressHotel")}：
                {holdOrder?.orderAddress || holdOrder?.hotel?.name || t("orderSubmit.unset")}
              </Typography>
              <Typography variant="body1">
                {t("orderSubmit.options")}：
                {holdOrder?.options?.map((option) => option.name).join("/")}
              </Typography>
              <Typography variant="body1">
                {t("orderSubmit.departureTime")}：
                {holdOrder?.departureTime
                  ? DateTimeUtils.toFormatAsLocalTimezone(
                      holdOrder.departureTime,
                      FORMAT_TYPE.YEAR_DATE_TIME
                    )
                  : t("orderSubmit.unset")}
              </Typography>
              <Typography variant="body1">
                {t("orderSubmit.planIn")}：
                {holdOrder?.planInTime
                  ? DateTimeUtils.toFormatAsLocalTimezone(
                      holdOrder.planInTime,
                      FORMAT_TYPE.YEAR_DATE_TIME
                    )
                  : t("orderSubmit.unset")}
              </Typography>
              <Typography variant="body1">
                {t("orderSubmit.planOut")}：
                {holdOrder?.planOutTime
                  ? DateTimeUtils.toFormatAsLocalTimezone(
                      holdOrder.planOutTime,
                      FORMAT_TYPE.YEAR_DATE_TIME
                    )
                  : t("orderSubmit.unset")}
              </Typography>
              <Typography variant="body1" style={{ marginTop: "20px" }}>
                {t("orderSubmit.cancelPrompt")}
              </Typography>
              <Box display="flex">
                <Button
                  className={classes.button}
                  color="default"
                  variant="contained"
                  onClick={() => {
                    setHoldOrder({} as OrderRes);
                    setDuplicateMessage(true);
                  }}
                >
                  {t("orderSubmit.no")}
                </Button>
                <Button
                  className={classes.button}
                  color="primary"
                  variant="contained"
                  onClick={async () => {
                    await OrderApi.cancel(companyId, {
                      orderId: holdOrder?.orderId,
                    });
                    setHoldOrder({} as OrderRes);
                    setDuplicateOrder(false);
                  }}
                >
                  {t("orderSubmit.yes")}
                </Button>
              </Box>
            </Box>
          )}
        </Box>
        <Box display="flex" justifyContent="center">
          <Select
            onChange={onChangeForm("status")}
            value={formData["status"] || "hold"}
          >
            {Object.entries(OrderStatus).map(([key, value]) => {
              return (
                <MenuItem value={key} key={key}>
                  {value}
                </MenuItem>
              );
            })}
          </Select>
          <Button
            variant="contained"
            className={classes.button}
            color="primary"
            onClick={onClickCreateOrder}
            disabled={
              (EnumUtils.mapToEnum(OrderStatus, oldOrder?.status) ===
                OrderStatus.paid &&
                !!orderId &&
                ![
                  StaffRole.notelMaster,
                  StaffRole.notelCallCenterPartTime,
                  StaffRole.notelCallCenterEmployee,
                  StaffRole.clientMaster,
                  StaffRole.clientShopMaster,
                ].includes(
                  EnumUtils.mapToEnum(StaffRole, staff.role) ||
                    StaffRole.clientShopPartTime
                )) ||
              duplicateOrder
            }
          >
            {t("orderSubmit.saveButton")}
          </Button>
        </Box>
      </Box>
      {duplicateMessage && (
        <Alert severity="error">
          <AlertTitle>
            {t("orderSubmit.duplicateAlert")}
          </AlertTitle>
        </Alert>
      )}
      {errorMessage && (
        <Alert severity="error">
          <AlertTitle>{t("orderSubmit.errorAlert")}</AlertTitle>
        </Alert>
      )}
      {isSuccess && (
        <Alert severity="success">
          <AlertTitle>{t("orderSubmit.successAlert")}</AlertTitle>
        </Alert>
      )}
    </>
  );
};
export default OrderSubmit;
